///<reference path="../../../../../typings/index.d.ts"/>

module Meevo.Components.Controls.HideInput {

    angular.module('meevo.components.controls.HideInput', []);
}
